module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "paid-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "paid-center-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/paid-information"
    }
  }, [_vm._v("付费资讯 > " + _vm._s(_vm.titArray[_vm.titIndex]))]), _vm._v(" "), _c('div', {
    staticClass: "paid-center-bg"
  }, [_vm._v("您还不是会员，请"), _c('router-link', {
    staticClass: "register",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("注册")]), _vm._v("会员。")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/paid-information-title?id=" + _vm.topIndex)
    }
  }, [_vm._v("上一篇：【付费资讯】" + _vm._s(_vm.titArray[_vm.topIndex]))]), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/paid-information-title?id=" + _vm.boottomIndex)
    }
  }, [_vm._v("下一篇：【付费资讯】" + _vm._s(_vm.titArray[_vm.boottomIndex]))])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paid-header"
  }, [_c('div', {
    staticClass: "paid-header-dw"
  }, [_c('div', {
    staticClass: "paid-header-tit"
  }, [_vm._v("付费资讯中心")]), _vm._v(" "), _c('div', {
    staticClass: "paid-header-search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入搜索内容"
    }
  }), _vm._v(" "), _c('button', [_vm._v("搜索")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("付费资讯")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d42bfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/paid-information/paid-title.vue
// module id = 1515
// module chunks = 1